import $ from 'jquery';
import '@mockup/func/globals/App.util';
import { App } from './App';

export const contactme = {
    init: function () {
        $('.contact-me-days-tags').on('click', 'li', function () {
            $('.contact-me-days-tags li').removeClass('active');

            $(this).addClass('active');
            var id = $(this).data('time-id');
            $('.contact-me-time').slideUp();

            if ($('.contact-me-days-tags li.active').length) {
                $('.contact-me-time#' + id).slideDown();
            } else {
                $('.contact-me-time').slideUp();
            }

            var reservationDate = $('input[id=reservationDate]').first();
            reservationDate.val('1');
            $('.contact-me-time-tags li').removeClass('active');
            var reservationTime = $('input[id=reservationTime]').first();
            reservationTime.val('');
        });

        $('.contact-me-time-tags').on('click', 'li', function () {
            $('.contact-me-time-tags li').removeClass('active');

            var reservationTime = $('input[id=reservationTime]').first();
            reservationTime.val($(this).data('from-value'));

            $(this).addClass('active');
        });

        function validateCallMe($form, submitButtonValue) {
            var valid = true;
            var name = $form.find('input[id=name]').first();
            var cpr = $form.find('input[id=cpr]').first();
            var email = $form.find('input[id=email]').first();
            var phone = $form.find('input[id=phone]').first();
            var details = $form.find('textarea[id=details]').first();

            valid = validateCallMeName(name);
            valid = validateRequiredField(details) && valid;
            valid = validateCallMePhone(phone) && valid;
            valid = validateCallMeCprAndCvr(cpr) && valid;
            valid = validateCallMeEmail(email, submitButtonValue) && valid;

            var dateValid = validateRequiredField($form.find('input[name=reservationDate]').first());
            valid = dateValid && valid;
            if (dateValid) {
                valid = validateRequiredField($form.find('input[name=reservationTime]').first()) && valid;
            }
            return valid;
        }

        $('form[data-callme-ajax="true"] input[id=name]').on('blur', function (event) { validateCallMeName($(event.target)); });
        $('form[data-callme-ajax="true"] input[id=cpr]').on('blur', function (event) { validateCallMeCprAndCvr($(event.target)); });
        $('form[data-callme-ajax="true"] input[id=phone]').on('blur', function (event) { validateCallMePhone($(event.target)); });
        $('form[data-callme-ajax="true"] input[id=email]').on('blur', function (event) { validateCallMeEmail($(event.target)); });
        $('form[data-callme-ajax="true"] textarea[id=details]').on('blur', function (event) { validateRequiredField($(event.target)); });

        function validateCallMeName(name) {
            return validateRequiredCallMe(name) && validateName(name);
        }

        function validateCallMePhone(phone) {
            return validateRequiredCallMe(phone) && validateTelefon(phone);
        }

        function validateRequiredCallMe(elem) {
            var errorElem = elem.nextAll('div .msg');
            errorElem.hide();
            var reqErrorElem = errorElem.filter('div[data-required="true"]');

            if (reqErrorElem.length > 0 && !required(elem)) {
                reqErrorElem.show();
                return false;
            } else if (reqErrorElem.length > 0) {
                reqErrorElem.hide();
            }
            return true;
        }

        function validateCallMeCprAndCvr(cpr) {
            var validCpr = modulus11Cpr(cpr);
            var validCvr = validateCvr(cpr);
            if (validCpr.cpr || validCvr) {
                setValidationOk(cpr);
                if (validCpr.cpr && !validCpr.modulus11) {
                    setValidationInfo(cpr);
                }
                return true;
            }
            return false;
        }

        function validateCallMeEmail(email, submitButtonValue) {
            if (submitButtonValue != undefined && submitButtonValue === 'online') {
                return validateRequiredCallMe(email) && validateEmail(email);
            } else {
                return validateEmail(email);
            }
        }

        $('form[data-callme-ajax="true"]').submit(function () {
            return false;
        });
        $('#uiBtnTlf, #uiBtnOnline').click(function (event) {

            var $form = $('#callMe');
            var submitButtonValue = $(this).attr('value');
            var valid = validateCallMe($form, submitButtonValue);
            var buttonVal = '&submitButtonName=' + submitButtonValue;
            var formdata = $form.serialize() + buttonVal;
            if (valid) {
                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    data: formdata
                }).done(function (data) {
                    if (data.success) {
                        $form.trigger('reset');
                        var header = $form.data('success-header');
                        var content = $form.data('success-content');
                        alertify.alert('<h3>' + header + '</h3><center><p>' + content + '</p></center>');
                        $('.contact-me-time').slideUp();
                        $('.contact-me-time-tags li').removeClass('active');
                        $('.contact-me-days-tags li').removeClass('active');
                        $('#divContact').slideUp();
                    } else {
                        alertify.alert(`<h3><center>${$form.data('error-header')}</center></h3><center><p>${$form.data('error-content')}</p><center/>`);
                    }
                });
            }

            return false;
        });
    }
};

export default contactme;

App.Util.contactme = contactme;


